import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InputRange from 'react-input-range'

export default class AllFilters extends Component {
  static propTypes = {
    applyFilter: PropTypes.func,
    minBudget: PropTypes.number.isRequired,
    maxBudget: PropTypes.number.isRequired,
    onChange: PropTypes.func,
  }

  state = {
    value: null,
  }

  constructor (props) {
    super(props)

    this.state = {
      value: { min: props.minBudget, max: props.maxBudget },
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      value: { min: nextProps.minBudget, max: nextProps.maxBudget },
    })
  }

  applyFilter = () => {
    this.props.applyFilter({
      minBudget: this.state.value.min,
      maxBudget: this.state.value.max,
    })
  }

  handleChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value.min, value.max)
    } else {
      this.setState({ value })
    }
  }

  formatSingleValue (value, type) {
    if (type === 'value') {
      if (value === 1 || value === 5) {
        return ''
      }
    }

    const text = []

    for (let i = 1; i <= value; i++) {
      text.push('€')
    }

    return text.join('')
  }

  render () {
    const { applyFilter } = this.props
    const { value } = this.state

    return (
      <>
        <div className='form__group'>
          <label className='form__label text-emphasis'>Budget</label>
          <div className='form__control'>
            <InputRange
              formatLabel={this.formatSingleValue}
              minValue={1}
              maxValue={5}
              value={value}
              onChange={this.handleChange}
            />
          </div>
        </div>

        {applyFilter && <button type='button' className='btn btn--primary filter-button' onClick={this.applyFilter}>Apply filters</button>}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/filters/Budget.js